import Conclave from '../components/conclave';

export default function Hrconclave() {
  return (
    <Conclave
      geturl="https://cpccbe.org/api/hrconclave/allmodals"
      createmodel1url="https://cpccbe.org/api/hrconclave/modal1"
      createmodel2url="https://cpccbe.org/api/hrconclave/modal2"
      updateurl="https://cpccbe.org/api/hrconclave/modal"
      deleteurl="https://cpccbe.org/api/hrconclave/modal"
      head="HR Conclave"
    />
  );
}
